import type { State } from './types.tsx';

const noop = () => {
	return null;
};

export const initialState: State = {
	isDeleteIssueModalOpen: false,
	didIssueDeleteFail: false,
	isDeletingIssue: false,
	issueKey: '',
	issueId: '',
	workType: null,
	isIssueArchivalEnabled: false,
	onIssueDeleteSuccess: noop,
	onIssueDeleteFailure: noop,
	onTriggerDeleteRequest: noop,
};
